export const setTermsForm = (termsFormOpen) => ({
  type: 'SET_TERMS_FORM_OPEN',
  termsFormOpen,
});
//Gurupreet
export const addToPendingSubmit = (pendingSubmitValues) => ({
  type: 'ADD_TO_PENDING_SUBMIT',
  pendingSubmitValues,
});

export const clearPendingSubmit = () => ({
  type: 'CLEAR_PENDING_SUBMIT',
});

export const handlePendingSubmitAction = (values, dispatch, props, name) => ({
  type: 'PROMPT_FOR_TERMS',
  pendingSubmitValues: values,
  name,
});

export const submitAmrDataForm = (values,dispatch, props) => ({
  type: 'CREATE_ENTITY_AMR',
  entityName: 'amr',
  values: values
});



export const submitAmrForm = (values,dispatch, props) => {
return {
  type: 'CREATE_ENTITY',
  entityName: 'amr',
  values: values
} }